module.exports = __webpack_public_path__ + "static/media/2.74d09725.jpg";